import { createStore } from "vuex";
import { config } from "vuex-module-decorators";

import FacturaModule from "@/store/modules/FacturaModule";
import ProveedorModule from "@/store/modules/ProveedorModule";
import EmpresaModule from "@/store/modules/EmpresaModule";
import AuthModule from "@/store/modules/AuthModule";
import SolicitudModule from "@/store/modules/SolicitudCuentaModule";
import UsuarioModule from "@/store/modules/UsuarioModule";
import TicketModule from "@/store/modules/TicketModule";
import BodyModule from "@/store/modules/BodyModule";
import BreadcrumbsModule from "@/store/modules/BreadcrumbsModule";
import ConfigModule from "@/store/modules/ConfigModule";
import GroupModule from "./modules/GroupModule";
import UploadModule from "./modules/UploadModule";
import LinkModule from "./modules/LinkModule";
import LicitacionModule from "./modules/LicitacionModule";
import NoticiaModule from "./modules/NoticiaModel";
import BancoModule from "./modules/BancoModule";
import LinkDocumentoModule from "./modules/LinkDocumentoModule";

config.rawError = true;

const store = createStore({
  modules: {
    FacturaModule,
    ProveedorModule,
    SolicitudModule,
    UsuarioModule,
    TicketModule,
    EmpresaModule,
    AuthModule,
    BodyModule,
    BreadcrumbsModule,
    ConfigModule,
    GroupModule,
    UploadModule,
    LinkModule,
    LicitacionModule,
    NoticiaModule,
    BancoModule,
    LinkDocumentoModule
  },
});

export default store;
